import { MessageSquareText } from "lucide-react";

import type { CaptionDisplay } from "@/audio/captions";

import "./accessibility.css";

export interface LiveCaptionProps {
  readonly caption: CaptionDisplay | null;
  readonly fallbackText?: string;
}

function getCaptionText(
  caption: CaptionDisplay | null,
  fallbackText?: string
): string {
  const liveText = caption?.text.trim();

  if (liveText) {
    return liveText;
  }

  return fallbackText?.trim() || "字幕准备中";
}

export function LiveCaption({ caption, fallbackText }: LiveCaptionProps) {
  const text = getCaptionText(caption, fallbackText);
  const mode = caption?.text.trim()
    ? caption.mode
    : fallbackText?.trim()
      ? "fallback"
      : "empty";

  return (
    <div className="a11y-live-caption" data-caption-mode={mode}>
      <MessageSquareText
        aria-hidden="true"
        className="a11y-live-caption__icon"
      />
      <span className="a11y-live-caption__label">字幕</span>
      <p
        aria-atomic="true"
        aria-live="polite"
        className="a11y-live-caption__text"
        role="status"
      >
        {text}
      </p>
    </div>
  );
}
